import { ReactElement } from 'react'
import { I18n, Translate } from 'common'
import { FilterGroupName } from 'results/constants'

export const getFilterGroupTitleKey = (groupName: string): string => {
  if (groupName === FilterGroupName.PART_TYPE) {
    return 'partType'
  }

  if (groupName === 'GFX') {
    return 'GFX'
  }

  return groupName
}

export const getFilterGroupTitleText = (groupName: string): string => {
  const titleKey = getFilterGroupTitleKey(groupName)
  if (titleKey === 'GFX') {
    return 'GFX'
  }

  return Translate(titleKey)
}

export const getFilterGroupTitle = (groupName: string): ReactElement => {
  const titleKey = getFilterGroupTitleKey(groupName)
  if (titleKey === 'GFX') {
    return <>GFX</>
  }

  return <I18n name={titleKey} />
}
